export const SET_TEMPLATE = 'WA/SET_TEMPLATE'
export const SET_TEMPLATES = 'WA/SET_TEMPLATES'
